import React from "react";
import PriceOption from "./PriceOption";
import { groupProductPrices } from "utils/price";
import classnames from "classnames";
import SectionBezel from "components/SectionBezel";
import { INTERVAL_LABELS_MAP } from "utils/constants/payment";

const PricesSelect = ({ prices, onSelect, activePrices }) => {
  const priceGroups = groupProductPrices(prices);
  const nodes = priceGroups.map(({ label, uid, sections }) => {
    const hasBreakdownSections = sections.length > 1;
    const ctxSections = hasBreakdownSections ? sections.slice(1) : sections;
    const groupNodes = ctxSections.reduce((memo, section, sectionIx) => {
      const pricesCount = section.prices.length;

      const subNodes = section.prices.map((price, priceIx) => {
        const isFirst = !priceIx;
        const isLast = priceIx === pricesCount - 1;
        const selected = activePrices.indexOf(price.id) > -1;
        return (
          <PriceOption
            onSelect={onSelect}
            selected={selected}
            key={price.id}
            isFirst={isFirst}
            isLast={isLast}
            priceIx={priceIx}
            price={price}
          />
        );
      });

      if (hasBreakdownSections) {
        subNodes.unshift(
          <label
            key={`label-${sectionIx}`}
            className={classnames("f7 f6-ns pb3 dib fw5", {
              pt3: sectionIx
            })}
          >
            {section.label}
          </label>
        );
      }
      memo = memo.concat(subNodes);
      return memo;
    }, []);

    const converted = INTERVAL_LABELS_MAP[label];

    return (
      <li className="pt3" key={uid}>
        <SectionBezel
          header={label}
          customClasses={{ header: { title: "fw6 f5 w-100" } }}
        >
          <ul className="ma0 pa0 list">{groupNodes}</ul>
        </SectionBezel>
      </li>
    );
  });

  return <ul className="w-100 ma0 pa0 list">{nodes}</ul>;
};

export default PricesSelect;
